import "antd/dist/reset.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import "react-toastify/dist/ReactToastify.css";
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
// import "~slick-carousel/slick/slick.css";
// import "~slick-carousel/slick/slick-theme.css";
import { AuthProvider } from "./context/AuthContext";
import { FilterProvider } from './context/FilterContext';
import { PurchaseProvider } from './context/PurchaseContext';
import { WishListProvider } from './context/WishListContext';
import './style.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <FilterProvider>
        <WishListProvider>
          <PurchaseProvider>
            <App />
          </PurchaseProvider>
        </WishListProvider>
      </FilterProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
